// ═══ 말소 셸 API 래퍼 (plan.md §11 B1 계약 · B3 리뷰 §2.2) — 서버 변경 0 ═══
// 반드시 utils/api.js 의 API + authFetch 를 경유한다 (상대경로 fetch 금지 — 서버 소스 가드).
// 성공: 서버 응답 body 그대로. 실패: Error(message) + { status, code, body } — simple/api.js 와 같은 정규화에
// body 를 덧붙인다(quick 의 CARNO_IN_PROGRESS existing[] · FIELD_REQUIRED index 등 code 밖 필드를 화면이 쓴다).
// multipart 는 headers 를 비워 둔다 — authFetch 가 FormData 면 Content-Type 을 건드리지 않는다.
import { API, authFetch } from '../../utils/api';

export { putLocale } from '../simple/api';

function apiError(status, body) {
  var b = body || {};
  var e = new Error(b.error || b.message || b.code || ('HTTP ' + status));
  e.status = status;
  e.code = b.code || '';
  e.body = b;
  return e;
}

function request(path, options) {
  return authFetch(API + path, options).then(function (res) {
    return res.json().catch(function () { return {}; }).then(function (body) {
      if (!res.ok || (body && body.success === false)) throw apiError(res.status, body);
      return body || {};
    });
  });
}

function jsonBody(method, path, payload) {
  return request(path, { method: method, body: JSON.stringify(payload || {}) });
}

function enc(id) { return encodeURIComponent(id); }

function query(params) {
  var q = [];
  Object.keys(params || {}).forEach(function (k) {
    var v = params[k];
    if (v === undefined || v === null || v === '') return;
    q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
  });
  return q.length ? '?' + q.join('&') : '';
}

/// 목록 — 활성 업체 스코프, 차량별 최신 비취소 1건. 배열(cr.* + carNo·vin·carType·staffPhone·serviceCount…)
export function listRequests() { return request('/cancel-requests'); }

/// 보강서류 요청 — 소속 전 업체(화면이 carId 교집합). status: '요청'|'제출'|'완료' 선택
export function myDocRequests(status) { return request('/cancel-doc-requests/my' + query({ status: status })); }

/// 말소증 보유 플래그 — { success, flags:{[id]:bool} }. ids ≤200
export function certFlags(ids) { return request('/cancel-requests/malso-cert-flags?ids=' + (ids || []).join(',')); }

/// 상세 — { success, request, car, services, hasMalsoCert, docRequests:{open,total} }
export function getRequest(id) { return request('/cancel-requests/' + enc(id)); }

/// 말소 신청(여러 대 한 트랜잭션) — 200 { success, agencyId, created[] } / 400·409 err.code + err.body
export function quickRequest(body) { return jsonBody('POST', '/cancel-requests/quick', body); }

/// 신청 취소 — 서버 상태 가드 없음(하드 삭제) → 호출측이 대기·접수일 때만
export function deleteRequest(id) { return request('/cancel-requests/' + enc(id), { method: 'DELETE' }); }

/// 보류 해제 — 400 '보류 상태가 아닙니다.'
export function unholdRequest(id) { return request('/cancel-requests/' + enc(id) + '/unhold', { method: 'POST' }); }

/// 보강서류 제출(multipart files ≤10) → status '제출'
export function submitDocFiles(id, files) {
  var fd = new FormData();
  Array.prototype.forEach.call(files || [], function (f) { fd.append('files', f); });
  return request('/cancel-doc-requests/' + enc(id) + '/submit', { method: 'POST', body: fd });
}

/// 말소증 바이너리 — authFetch Response 그대로(.json() 금지). 호출측이 res.ok 확인 후 blob()
export function fetchMalsoCert(id) { return authFetch(API + '/cancel-requests/' + enc(id) + '/malso-cert'); }

/// 말소증 공유 링크 — { success, url, expiresAt } / 404
export function malsoShare(id) { return request('/cancel-requests/' + enc(id) + '/malso-share', { method: 'POST' }); }

/// 거래처 말소 장부 월 조회 (B4 · routes/myCancelLedger.js) — params { month:'YYYY-MM' } →
/// { success, month, minMonth, agency:{id,name}|null, linkedAt, linkedBalance, opening, charged, paid, closing, rows[] }
/// 400 COMPANY_REQUIRED·INVALID_MONTH / 403 대행사 계정
export function myCancelLedger(params) { return request('/my/cancel-ledger' + query(params)); }

/// 월 정산서 PDF — JWT 필요라 <a href> 불가. authFetch Response 그대로(.json() 금지) — 호출측이 res.ok 확인 후 blob()
/// unitId > 0 (대행사의 거래처별 보기) 일 때만 query 에 싣는다 — 그 거래처 청구 내역·합계만 담긴 PDF.
export function fetchMyCancelLedgerPdf(month, unitId) {
  return authFetch(API + '/my/cancel-ledger/pdf' + query({ month: month, unitId: unitId > 0 ? unitId : undefined }));
}

/// 대행사 거래처 목록 — { success, isBroker, accountId, accountName, clients:[{id,name,isSelf,joined,pickupAddress,lastRequestDate}] }
/// 비대행사 = isBroker:false · clients:[] · 400 COMPANY_REQUIRED · 403 말소대행사 계정
export function listMalsoClients() { return request('/my/malso-clients'); }

/// 거래처 추가(대행사 대표만) — body { name, bizNo?, pickupAddress? } (빈 값 키 생략은 호출측) → { success, client }
/// 403 OWNER_ONLY · 409 UNIT_NAME_EXISTS(err.body.id = 같은 이름 거래처) · 400 이름 없음/길이
export function addMalsoClient(body) { return jsonBody('POST', '/my/malso-clients', body); }

/// 거래처 수거 주소 수정 — pickupAddress '' = 지움 → { success, client } · 404 UNIT_NOT_FOUND
export function putMalsoClientPickup(id, pickupAddress) {
  return jsonBody('PUT', '/my/malso-clients/' + enc(id), { pickupAddress: pickupAddress });
}

/// 거래처 초대 링크 발급(대행사 대표만) — { success, url, expiresAt, unitName, agencyName, issuerName }
/// 403 OWNER_ONLY · 404 UNIT_NOT_FOUND · 400 UNIT_ALREADY_LINKED·UNIT_INACTIVE
export function inviteMalsoClient(id) { return jsonBody('POST', '/my/malso-clients/' + enc(id) + '/invite', {}); }

/// 대행사(active=1 만) — 배열
export function listAgencies() { return request('/cancel-agencies'); }

/// 대행사 부가서비스 — 배열 [{id,name,…}]
export function extraServices(agencyId) { return request('/cancel-agencies/' + enc(agencyId) + '/extra-services'); }

/// 바이어(활성 업체) — 배열. 수출말소 바이어 이름 자동완성
export function listBuyers() { return request('/buyers'); }

/// 본인 정보 — 사용자 행 + 회사 플래그(simpleMode·malsoMode·malsoJoin …, routes/auth.js attachCompanyFlags). success 키 없음.
export function getMe() { return request('/users/me'); }

/// 대표 셀프 전환 — { success, malsoMode } / 403 OWNER_ONLY. 세션 갱신은 호출측(moreActions.applyMalsoMode)
export function putMalsoMode(enabled) { return jsonBody('PUT', '/settings/malso-mode', { enabled: enabled ? 1 : 0 }); }

/// 업체 정보 — { companyName, bizNo, ceo, addrKr, tel, email, bizType, bizItem, pickupAddress, … }
/// cid 0/없음이면 서버가 전역 company_settings 행을 200 으로 준다(routes/settings.js:212) → 보내지 않고 reject.
export function getCompany(cid) {
  if (!(Number(cid) > 0)) return Promise.reject(apiError(0, { code: 'COMPANY_ID_REQUIRED', error: 'companyId 필수' }));
  return request('/settings/company' + query({ companyId: cid }));
}

// PUT /settings/company-info 가 body 에 없는 칸을 '' 로 덮어쓰는 7키(routes/settings.js:316-323).
var COMPANY_INFO_KEYS = ['bizNo', 'ceo', 'address', 'bizType', 'bizItem', 'tel', 'email'];

/// 업체 정보 저장 — getCompany 로 읽은 값 전부 재전송(B1 한계). 7키 중 하나라도 undefined 면 서버로
/// 보내지 않고 reject(COMPANY_INFO_INCOMPLETE) — pickupAddress 만 보내면 회사 정보가 지워진다.
export function putCompanyInfo(body) {
  var b = body || {};
  var missing = COMPANY_INFO_KEYS.filter(function (k) { return b[k] === undefined; });
  if (missing.length) {
    return Promise.reject(apiError(0, { code: 'COMPANY_INFO_INCOMPLETE', error: '업체 정보 누락: ' + missing.join(','), missing: missing }));
  }
  return jsonBody('PUT', '/settings/company-info', b);
}
